import { ActionIcon } from "@mantine/core";
import { IconPin } from "@tabler/icons-react";
import React, { useState } from "react";

const Pinner = ({ row, editor, setRows }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    setLoading(true);
    editor({ id: row.id, pin: !row.pin })
      .then((res) => {
        if (row.pin === false) {
          setRows((prev) => {
            let newRows = [...prev];
            let index = newRows.findIndex((x) => x.id === row.id);
            newRows.splice(index, 1); // Remove the item
            newRows.unshift({ ...row, pin: !row.pin });

            return newRows;
          });
        } else {
          setRows((prev) => {
            let newRows = [...prev];
            let index = newRows.findIndex((x) => x.id === row.id);

            newRows[index] = { ...newRows[index], pin: !row.pin };

            return newRows.sort((a, b) => {
              // Sort by pin first
              if (b.pin !== a.pin) {
                return b.pin - a.pin;
              }
              // If pin is the same, sort by id descending
              return b.id - a.id;
            });
          });
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <ActionIcon
      className={loading || row?.pin ? "" : "hover-target"}
      pos={"absolute"}
      top={"-50%"}
      right={-20}
      variant={row?.pin ? "filled" : "white"}
      style={{ zIndex: 4, borderTopRightRadius: 42 }}
      size={"sm"}
      loading={loading}
      onClick={handleClick}
    >
      <IconPin size={16} />
    </ActionIcon>
  );
};

export default Pinner;
